<template>
    <div class="joinContent">
        <div v-if="joinData.partner_status == '0'">
            <el-image :src="require('@/assets/image/joinBg.png')" fit="cover" class="joinBg"></el-image>
            <div class="joinBox">
                <!-- 介绍 -->
                <div class="briefBox flex">
                    <div class="briefLeft">
                        <div class="briefTitle">{{joinData.topTitle2}}</div>
                        <div class="brief">{{joinData.topDesc2}}</div>
                    </div>
                    <div class="briefTips center">
                        <el-image :src="require('@/assets/icon/joinTriangle.png')" fit="cover" class="briefIcon"></el-image>
                        <div v-html="joinData.topDetail"></div>
                    </div>
                </div>
                <div class="joinBottom spb">
                    <!-- 利润 -->
                    <div class="joinProfit column">
                        <div class="profitTitle">{{joinData.topProfit}}利润</div>
                        <div class="profitBox between" v-for="(item,index) in joinData.list1" :key="index">
                            <div class="align" style="flex: 1;">
                                <el-image :src="item.img" fit="cover" class="profitImg"></el-image>
                                <div>
                                    <div class="profitName">{{item.name}}</div>
                                    <div class="profitTips">{{item.title}}</div>
                                </div>
                            </div>
                            <div class="profit">{{item.desc}}<span class="profitNum">{{item.profit}}</span></div>
                        </div>
                    </div>
                    <div class="joinRight">
                        <!-- 品类 -->
                        <div class="cateContent">
                            <div class="cateBox column">
                                <div class="cateTop">赚钱品类大全 长久更新</div>
                                <div class="cateList flex">
                                    <div class="cate column" v-for="(item,index) in joinData.list2" :key="index">
                                        <el-image :src="item.img" fit="cover" class="cateIcon"></el-image>
                                        <div class="cateName">{{item.name}}</div>
                                        <div class="cateTitle">{{item.title}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="joinRB spb">
                            <!-- 合伙人交付 -->
                            <div class="joinDeliver column">
                                <div class="profitTitle" v-if="joinData.partner_jiaofu != '0'">合伙人交付</div>
                                <div class="deliverList flex" v-if="joinData.partner_jiaofu != '0'">
                                    <div class="deliverBox column" v-for="(item,index) in joinData.partner_jiaofudata" :key="index">
                                        <el-image :src="item.img" fit="cover" class="deliverIcon"></el-image>
                                        <div class="deliverName">{{item.name}}</div>
                                        <div class="deliverTitle">{{item.title}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- 分红 -->
                            <div class="bonusBox column" v-if="joinData.partner_fenhong != '0'">
                                    <div class="bonusTitle">合伙人分红</div>
                                    <div class="bonusTips">{{joinData.inviteDesc}}</div>
                                    <div class="bonusNum">{{joinData.inviteMoney}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="joinPayBtn" v-if="!joinData.partner_status" @click="joinPayBtnTap">立即支付<span class="btnIcon">￥</span><span class="btnNum">{{joinData.payMoney}}</span>/{{joinData.partner_type ? '永久' : '年'}}</div>
        </div>
        <div class="isVip" v-if="joinData.partner_status == '1'">
            <el-image :src="require('@/assets/icon/joinVip.png')" fit="cover" class="joinVip"></el-image>
            <div class="vipTitle">合伙人中心</div>
            <div class="flex">
                <div class="residueBox between">
                    <div class="residue" style="padding-right: 32px;">{{joinCenterData.partner_desc}}</div>
                    <div class="align" v-if="joinCenterData.partner_type == '0'">
                        <div class="residue">续费</div>
                        <el-image :src="require('@/assets/icon/residue.png')" fit="cover" class="residueIcon"></el-image>
                    </div>
                </div>
            </div>
            <div class="privilegeList flex">
                <div class="privilegeBox" v-for="(item,index) in joinCenterData.list" :key="index" @click="privilegeTap(item.url)">
                    <div class="privilegeName">{{item.name}}</div>
                    <el-image :src="item.img" fit="cover" class="privilegeIcon"></el-image>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                joinData: {},
                joinCenterData: {}
            }
        },
        created(){
            this.getJoin()
        },
        methods: {
            // 获取头像昵称
            getJoin(){
                this.request.get("api/partner/index",{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    this.joinData = res.data
                    if(res.data.partner_status == '1'){
                        this.getJoinCenter()
                    }
                })
            },
            // 合伙人中心
            getJoinCenter(){
                this.request.get("api/Partner/partner_center",{
                    params:{
                        userid: localStorage.getItem("userId") || 0
                    }
                })
                .then(res=>{
                    this.joinCenterData = res.data
                })
            },
            // 立即支付
            joinPayBtnTap(){}
        }
    }
</script>
<style lang="less" scoped>
    .joinContent{
        width: 1568px;
        position: relative;
        z-index: 2;
        .joinBg{
            width: 1568px;
            height: 295px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 3;
        }
        .joinBox{
            width: 1568px;
            position: relative;
            z-index: 4;
            .briefBox{
                width: 952px;
                height: 117px;
                padding-left: 32px;
                background: #242424;
                border-radius: 16px;
                margin: 46px 0 0 555px;
                .briefLeft{
                    width: 266px;
                    .briefTitle{
                        font: bold 22px/26px "Microsoft YaHei";
                        color: #fff;
                        margin-top: 24px;
                    }
                    .brief{
                        font: 14px/18px "Microsoft YaHei";
                        color: #E4C1A2;
                        margin-top: 6px;
                    }
                }
                .briefTips{
                    width: 624px;
                    height: 72px;
                    padding: 0 16px;
                    background: linear-gradient( 180deg, #FFFFFF 0%, #FFF6E4 100%), #D9D9D9;
                    border-radius: 16px;
                    position: relative;
                    z-index: 5;
                    margin: 32px 0 0 10px;
                    font: 14px/18px "Microsoft YaHei";
                    color: #5A4935;
                    .briefIcon{
                        width: 10px;
                        height: 18px;
                        position: absolute;
                        left: -9px;
                        top: 27px;
                        z-index: 6;
                    }
                }
            }
            .joinBottom{
                margin-top: 56px;
                .joinProfit{
                    width: 427px;
                    padding: 32px 0;
                    background: linear-gradient( to bottom, #FEF8ED 0%, #fff 100%);
                    border-radius: 16px;
                    .profitTitle{
                        font: bold 22px/30px "Microsoft YaHei";
                        color: #262626;
                        margin-bottom: 4px;
                    }
                    .profitBox{
                        width: 364px;
                        padding: 9px 16px;
                        border-radius: 16px;
                        margin-bottom: 8px;
                        .profitImg{
                            width: 48px;
                            height: 48px;
                            margin-right: 4px;
                        }
                        .profitName{
                            font: 18px/24px "Microsoft YaHei";
                        }
                        .profitTips{
                            font: 14px/18px "Microsoft YaHei";
                            color: #73727A;
                            margin-top: 4px;
                        }
                        .profit{
                            font: 14px/24px "Microsoft YaHei";
                            color: #7E4C1E;
                            .profitNum{
                                font: bold 18px/24px "Microsoft YaHei";
                                color: #F34646;
                            }
                        }
                    }
                }
                .joinRight{
                    width: 1062px;
                    .cateContent{
                        width: 1060px;
                        padding: 1px;
                        background: linear-gradient( to bottom, #ff3939, #cc39ff);
                        border-radius: 16px;
                        .cateBox{
                            width: 1060px;
                            padding: 24px 0;
                            background: linear-gradient(#F8E2E6 0%, #fff 78%);
					        border-radius: 16px;
                            .cateTop{
                                font: bold 24px/32px "Microsoft YaHei";
                                color: #262626;
                            }
                            .cateList{
                                width: 1000px;
                                margin-top: 16px;
                                .cate{
                                    width: 200px;
                                    margin: 8px 0;
                                    .cateIcon{
                                        width: 56px;
                                        height: 56px;
                                        margin-top: 8px;
                                    }
                                    .cateName{
                                        font: 18px/24px "Microsoft YaHei";
                                        color: #360038;
                                        margin-top: 8px;
                                    }
                                    .cateTitle{
                                        font: 14px/18px "Microsoft YaHei";
                                        color: #A13939;
                                        margin: 4px 0;
                                    }
                                }
                            }
                        }
                    }
                    .joinRB{
                        width: 1062px;
                        margin-top: 16px;
                        .joinDeliver{
                            width: 618px;
                            height: 222px;
                            background: #fff;
                            border-radius: 16px;
                            border: 1px solid #EBEBEB;
                            .profitTitle{
                                font: bold 24px/32px "Microsoft YaHei";
                                color: #262626;
                                margin-top: 16px;
                            }
                            .deliverList{
                                width: 560px;
                                margin-top: 16px;
                                .deliverBox{
                                    width: 140px;
                                    .deliverIcon{
                                        width: 56px;
                                        height: 56px;
                                        margin-top: 12px;
                                    }
                                    .deliverName{
                                        font: 16px/20px "Microsoft YaHei";
                                        margin-top: 4px;
                                    }
                                    .deliverTitle{
                                        font: 14px/18px "Microsoft YaHei";
                                        color: #ADACB1;
                                        margin-top: 4px;
                                    }
                                }
                            }
                        }
                        .bonusBox{
                            width: 428px;
                            height: 222px;
                            background: #fff;
                            border-radius: 16px;
                            border: 1px solid #EBEBEB;
                            .bonusTitle{
                                font: bold 24px/32px "Microsoft YaHei";
                                color: #262626;
                                margin-top: 16px;
                            }
                            .bonusTips{
                                font: 16px/22px "Microsoft YaHei";
                                color: #561111;
                                margin-top: 42px;
                            }
                            .bonusNum{
                                font: bold 32px/42px "Microsoft YaHei";
                                color: #FF1414;
                                margin-top: 12px;
                            }
                        }
                    }
                }
            }
        }
        .joinPayBtn{
            width: 392px;
            height: 64px;
            background: linear-gradient( 90deg, #F5DCB0 0%, #EABE70 100%);
            box-shadow: 0px 4px 24px 0px rgba(148,62,0,0.15);
            border-radius: 32px;
            position: fixed;
            right: calc((100vw - 720px)/2);
            bottom: 50px;
            z-index: 7;
            font: 24px/64px "Microsoft YaHei";
            color: #351D00;
            text-align: center;
            cursor: pointer;
            .btnIcon{
                font: bold 20px/64px "Microsoft YaHei";
            }
            .btnNum{
                font: bold 28px/64px "Microsoft YaHei";
            }
        }
        .isVip{
            width: 1504px;
            height: calc(100vh - 103px);
            padding: 0 32px;
            background: #fff linear-gradient( to bottom, #2E292F 250px, rgba(46,41,47,0) 367px);
            position: relative;
            display: flex;
            flex-direction: column;
            .joinVip{
                width: 215px;
                height: 140px;
                position: absolute;
                top: 13px;
                right: 181px;
                z-index: 2;
            }
            .vipTitle{
                font: bold 30px/42px "Microsoft YaHei";
				color: #F3AF71;
				margin: 50px 0 10px 80px;
            }
            .residueBox{
				padding: 0 12px;
				height: 30px;
				background: #131215;
				border-radius: 15px;
                margin-left: 80px;
                cursor: pointer;
				.residue{
					font: 16px/30px simhei;
					color: #ECDDCC;
				}
				.residueIcon{
					width: 16px;
					height: 16px;
				}
			}
            .privilegeList{
				width: 1454px;
				min-height: calc(100vh - 290px);
				padding: 46px 24px;
				background: linear-gradient( to bottom, #FEF1E4 0%, #FEFEFE 100%);
                border: 1px solid #F3EFE8;
				border-radius: 16px;
				margin-top: 20px;
				align-content: flex-start;
				.privilegeBox{
					width: 345px;
                    height: 160px;
					background: linear-gradient( 134deg, #FCF1E9 0%, #FCD9BE 100%);
					border-radius: 16px;
					border: 1px solid #EAD4C0;
					margin: 8px;
					position: relative;
					z-index: 5;
                    cursor: pointer;
                    &:hover{
                        box-shadow: 0 2px 20px 0 rgba(0,0,0,0.08);
                    }
					.privilegeName{
						font: bold 20px/26px simhei;
						color: #491E11;
						padding: 0 36px;
						margin-top: 36px;
					}
					.privilegeIcon{
						width: 44px;
						height: 44px;
						position: absolute;
						right: 36px;
						bottom: 36px;
						z-index: 6;
					}
				}
			}
        }
    }
</style>